import Swiper from "swiper/bundle";
import Vimeo from "@vimeo/player";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import { debounce } from "lodash-es";
import { MobileDetect } from "@/scripts/utils";

function zoom(e) {
  var offsetX, offsetY, x, y;
  var zoomer = e.currentTarget;
  e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
  e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
  x = (offsetX / zoomer.offsetWidth) * 100;
  y = (offsetY / zoomer.offsetHeight) * 100;
  zoomer.style.backgroundPosition = x + "% " + y + "%";
}

class ProductGallery extends window.HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const thumbsCarousel = new Swiper(".thumbs-carousel .swiper", {
      loop: false,
      freeMode: true,
      slidesPerView: "auto",
      spaceBetween: 8,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      threshold: 20,
      breakpoints: {
        1024: {
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          spaceBetween: 10,
        },
      },
      observer: true,
      observeParents: true,
    });

    function zoomEvent() {
      document.querySelectorAll(".zoom-group").forEach((zoomGroup) => {
        zoomGroup.addEventListener("mousemove", zoom);
      });
    }

    function resizeEvent() {
      document.addEventListener("resize", () => {
        if (!MobileDetect.isMobile && window.innerWidth >= 1024) {
          zoomEvent();
        } else {
          // Remove zoom event
          document.querySelectorAll(".zoom-group").forEach((zoomGroup) => {
            zoomGroup.removeEventListener("mousemove", zoom);
          });
        }
      });
    }

    const resizeDebounce = debounce(resizeEvent, 250);

    window.addEventListener("resize", resizeDebounce);

    if (!MobileDetect.isMobile && window.innerWidth >= 1024) {
      zoomEvent();
    } else {
      // Remove zoom event
      document.querySelectorAll(".zoom-group").forEach((zoomGroup) => {
        zoomGroup.removeEventListener("mousemove", zoom);
      });
    }

    function playActiveSlideMedia(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];

      if (activeSlide) {
        const mediaType = activeSlide.dataset.mediaType;

        switch (mediaType) {
          case "video":
            activeSlide.querySelector(".video-player").play();
            break;
          case "youtube":
            activeSlide.querySelectorAll("iframe").forEach((iframe) => {
              iframe.contentWindow.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                "*"
              );
            });
            break;
          case "vimeo":
            const vimeoPlayer = new Vimeo(activeSlide);

            vimeoPlayer.play();
            break;
        }
      }

      const previousSlide = swiper.slides[swiper.previousIndex];

      if (previousSlide && swiper.previousIndex !== swiper.activeIndex) {
        const mediaType = previousSlide.dataset.mediaType;

        switch (mediaType) {
          case "video":
            document.querySelectorAll(".js-video").forEach((video) => {
              video.pause();
              video.currentTime = 0;
            });
            break;
          case "youtube":
            document.querySelectorAll(".js-youtube").forEach((video) => {
              video.contentWindow.postMessage(
                '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                "*"
              );
            });
            break;
          case "vimeo":
            const vimeoPlayer = new Vimeo(previousSlide);

            vimeoPlayer.pause();
            vimeoPlayer.setCurrentTime(0);
            break;
        }
      }
    }

    function initGallery(mediaJson) {
      const dataSource = [];

      if (!mediaJson) return;

      if (mediaJson.length === 0) return;

      mediaJson.forEach((media) => {
        if (media.media_type === "image") {
          dataSource.push({
            src: media.src,
            width: media.width,
            height: media.height,
          });
        }
      });

      const lightbox = new PhotoSwipeLightbox({
        dataSource,
        pswpModule: () => import("photoswipe"),
      });

      lightbox.init();

      const productSlider = document.querySelector(".product-slider");

      productSlider.addEventListener("click", (event) => {
        if (event.target.classList.contains("open-gallery")) {
          event.preventDefault();

          const mediaIndex = event.target.getAttribute("data-index");

          if (!mediaIndex) {
            return;
          }

          const index = parseInt(mediaIndex);

          if (isNaN(index)) {
            return;
          }

          lightbox.loadAndOpen(index, dataSource);
        }
      });
    }

    const mediaString = this.getAttribute("media");

    if (mediaString) {
      const mediaJson = JSON.parse(mediaString);

      initGallery(mediaJson);
    }

    const productSlider = new Swiper(".product-slider .swiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      thumbs: {
        swiper: thumbsCarousel,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: (swiper) => {
          playActiveSlideMedia(swiper);
        },
        slideChangeTransitionStart: (swiper) => {
          playActiveSlideMedia(swiper);

          const activeSlide = swiper.slides[swiper.activeIndex];
          const zoomGroup = activeSlide.querySelector(".zoom-group");

          if (!MobileDetect.isMobile) {
            zoomGroup.addEventListener("mousemove", zoom);
          }
        },
      },
    });
  }
}

window.customElements.define("product-gallery", ProductGallery);
